/**
 * Google Analytics 4 (gtag) — solo tras aceptar cookies
 **/

function getGaMeasurementId() {
    return window.__GA_MEASUREMENT_ID__
        || window.__SORTEO_FIREBASE__?.measurementId
        || null;
}

function ensureGtag() {
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
        window.gtag = function gtag(){ window.dataLayer.push(arguments); };
    }
    return window.gtag;
}

export function initAnalyticsConsentDefaults() {
    const gtag = ensureGtag();

    gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
    });
}

function loadGtagScript(measurementId) {
    if (!measurementId) return;
    if (document.querySelector(`script[data-gtag="true"][data-id="${measurementId}"]`)) return;
    const script = document.createElement('script');
    script.async = true;
    script.dataset.gtag = 'true';
    script.dataset.id = measurementId;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
}

export function purgeAnalyticsScripts() {
    const measurementId = getGaMeasurementId();
    if (!measurementId) return;
    document.querySelectorAll(`script[src*="googletagmanager.com/gtag/js"][src*="${measurementId}"]`).forEach(s => s.remove());
    document.querySelectorAll(`script[data-gtag="true"][data-id="${measurementId}"]`).forEach(s => s.remove());
}

export function enableAnalytics() {
    const measurementId = getGaMeasurementId();
    if (!measurementId) {
        console.warn('GA4: falta gaMeasurementId en data.json → config.gaMeasurementId');
        return;
    }

    const gtag = ensureGtag();
    gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
    });
    loadGtagScript(measurementId);
    gtag('js', new Date());
    gtag('config', measurementId);
}

export function disableAnalytics() {
    const gtag = ensureGtag();
    gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied'
    });
}

/** @deprecated Use enableAnalytics() after cookie consent */
export function initAnalytics() {
    initAnalyticsConsentDefaults();
    enableAnalytics();
}
